const files = require.context(
  '@stone-payments/jade-design-tokens/icons',
  false,
  /.svg$/
)
const fileNames = files.keys().map(key => key.slice(2, -4)) // ./action-attachment.svg to action-attachment

export default fileNames
